import React from 'react'
import Toggle from 'components/Toggle'

const PricingToggle = ({ professionalMode, handleProfessionalModeChange, editions }) => {
    return (
        <div className="relative inline-flex min-h-[20px] items-center justify-center overflow-hidden border-dashed border-gray-accent-light">
            <Toggle
                iconLeft={<span className="text-sm">{editions?.[0]?.title}</span>}
                iconRight={<span className="text-sm">{editions?.[1]?.title}</span>}
                checked={professionalMode}
                onChange={(checked) => handleProfessionalModeChange(checked)}
            />
        </div>
    )
}

export default PricingToggle
